import { useState, FC, useEffect } from "react";
import dayjs from "dayjs";
import "./CustomDatePicker.css";
import DayView from "./DayView";

interface WeekViewProps {
  initialDate: dayjs.Dayjs;
  onDateSelect?: (date: dayjs.Dayjs) => void;
  selectedDate?: dayjs.Dayjs;
}

const WeekView: FC<WeekViewProps> = ({
  initialDate,
  onDateSelect,
  selectedDate: propSelectedDate,
}) => {
  const [selectedDate, setSelectedDate] = useState<dayjs.Dayjs>(
    propSelectedDate || initialDate
  );

  // Update local state when prop changes
  useEffect(() => {
    if (propSelectedDate) {
      setSelectedDate(propSelectedDate);
    }
  }, [propSelectedDate]);

  const onDateClick = (date: dayjs.Dayjs) => {
    setSelectedDate(date);
    if (onDateSelect) {
      onDateSelect(date);
    }
  };

  const buildDays = (start: dayjs.Dayjs, end: dayjs.Dayjs) => {
    let days = [];
    let dateDiffInDays = end.diff(start, "day");

    for (let i = 0; i <= dateDiffInDays; i++) {
      let current = start.add(i, "day");

      days.push(
        <DayView
          key={i}
          current={current}
          onDateClick={onDateClick}
          selectedDate={selectedDate}
        />
      );
    }

    return days;
  };

  const render = () => {
    let start = initialDate.day(0);
    let end = initialDate.day(6);

    return (
      <div className="cb-date-list">
        <div className="cb-month-container">
          <div className="cb-days-container">{buildDays(start, end)}</div>
        </div>
      </div>
    );
  };

  return <>{render()}</>;
};

export default WeekView;
